export default __webpack_public_path__ + "static/gma-logo-white-4625c48be478086eeec9e8fd3e7de7d6.svg";